import type en from "../en/common";
import type { Translation } from "../../types";

const common: Translation<typeof en> = {
  actions: {
    add: "Ajouter",
    back: "Retour",
    cancel: "Annuler",
    close: "Fermer",
    confirm: "Confirmer",
    copy: "Copier",
    copied: "Copié",
    create: "Créer",
    delete: "Supprimer",
    done: "Terminé",
    download: "Télécharger",
    edit: "Modifier",
    keep: "Conserver",
    move: "Déplacer",
    open: "Ouvrir",
    remove: "Retirer",
    rename: "Renommer",
    retry: "Réessayer",
    save: "Enregistrer",
    saving: "Enregistrement…",
    search: "Rechercher",
    send: "Envoyer",
    tryAgain: "Réessayer",
    upload: "Importer un fichier",
  },
  states: {
    loading: "Chargement…",
    working: "En cours…",
  },
  status: {
    scheduled: "Planifié",
    recording: "Enregistrement",
    processing: "En traitement",
    ready: "Prêt",
    failed: "Échec",
    partial: "Partiel",
    uploadFailed: "Échec de l’envoi",
    waitingToBeLetIn: "En attente d’admission",
  },
  platform: {
    zoom: "Zoom",
    google_meet: "Google Meet",
    teams: "Teams",
    upload: "Fichier importé",
    studio: "Montage Studio",
    youtube: "YouTube",
    linkedin: "LinkedIn",
  },
  roles: {
    user: "Membre",
    creator: "Créateur",
    admin: "Administrateur",
    super_admin: "Propriétaire",
  },
  errors: {
    generic: "Cela n’a pas fonctionné.",
    network: "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
  },
  language: {
    label: "Langue",
    choose: "Choisir une langue",
  },
  optional: "facultatif",
} as const;

export default common;
